import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserNPCFollowingDemo from 'src/games/demos/npcFollowingDemo/Main';

interface NPCFollowingDemoProps extends PageProps<{}> {
}

class NPCFollowingDemo extends React.Component<NPCFollowingDemoProps> {
    private game: Phaser.Game;
    constructor(props: NPCFollowingDemoProps) {
        super(props);
        bindAllOfThis(this, NPCFollowingDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserNPCFollowingDemo />
        </div>);
    }
}

export default NPCFollowingDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/NPCFollowingDemo.tsx